import { Icon } from "./Icon.jsx";
export function ReviewCard({ review }) {
  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div style={{padding:"16px", background:"var(--surface)", border:"1px solid var(--border)", borderRadius:"4px"}}>
      {/* Header: rating, name, date */}
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"12px"}}>
        <div>
          {/* Star rating */}
          <div style={{display:"flex", gap:"2px", marginBottom:"4px"}}>
            {[1,2,3,4,5].map(i => (
              <span key={i} style={{fontSize:"14px", opacity: i <= review.rating ? 1 : 0.3}}>★</span>
            ))}
          </div>
          
          {/* Name and date */}
          <div style={{fontSize:"13px", fontWeight:600, color:"var(--ink)"}}>
            Customer Review
          </div>
          <div style={{fontSize:"12px", color:"var(--ink-soft)"}}>
            {formatDate(review.created_at)}
          </div>
        </div>
      </div>
      
      {/* Review text */}
      {review.review_text && (
        <p style={{fontSize:"13px", color:"var(--ink)", lineHeight:"1.5", margin:"8px 0", whiteSpace:"pre-wrap"}}>
          {review.review_text}
        </p>
      )}
      
      {/* Photos */}
      {review.photos && Array.isArray(review.photos) && review.photos.length > 0 && (
        <div style={{display:"flex", gap:"8px", marginTop:"12px", flexWrap:"wrap"}}>
          {review.photos.map((photo, idx) => (
            <img 
              key={idx}
              src={photo}
              style={{width:"80px", height:"80px", borderRadius:"4px", objectFit:"cover", cursor:"pointer"}}
              alt={`Review photo ${idx + 1}`}
            />
          ))}
        </div>
      )}
      
      {/* Helpful counter */}
      {review.helpful_count > 0 && (
        <div style={{marginTop:"12px", fontSize:"12px", color:"var(--ink-soft)", display:"flex", gap:"6px", alignItems:"center"}}>
          <Icon n="thumbs-up" size="1.1em" inline /> {review.helpful_count} people found this helpful
        </div>
      )}
    </div>
  );
}
